import { create } from 'zustand';

export interface ConfirmOptions {
  title: string;
  description?: string;
  confirmLabel?: string;
  /** Rode bevestigknop, voor verwijderen en overschrijven. */
  destructive?: boolean;
}

interface ConfirmRequest extends ConfirmOptions {
  resolve: (confirmed: boolean) => void;
}

export const useConfirmRequest = create<{ request: ConfirmRequest | null }>(() => ({
  request: null,
}));

/**
 * Vraagt bevestiging in de app zelf. In de HubSpot-iframe geeft `window.confirm`
 * zonder melding `false` terug, waardoor de actie daar nooit doorging.
 */
export function confirmAction(options: ConfirmOptions): Promise<boolean> {
  return new Promise((resolve) => {
    useConfirmRequest.getState().request?.resolve(false);
    useConfirmRequest.setState({ request: { ...options, resolve } });
  });
}

export function settleConfirm(confirmed: boolean) {
  const { request } = useConfirmRequest.getState();
  if (!request) return;
  useConfirmRequest.setState({ request: null });
  request.resolve(confirmed);
}
